import { useState, useEffect } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { List, X } from "@phosphor-icons/react";

const NAV = [
  { to: "/", label: "Home" },
  { to: "/services", label: "Services" },
  { to: "/pricing", label: "Pricing" },
  { to: "/about", label: "About" },
  { to: "/referral", label: "Referral Program" },
  { to: "/contact", label: "Contact" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => { setOpen(false); }, [location.pathname]);

  return (
    <header
      data-testid="navbar"
      className={`fixed top-0 inset-x-0 z-50 transition-[background-color,border-color,backdrop-filter] duration-300 ${
        scrolled ? "bg-white/70 backdrop-blur-xl border-b border-black/10" : "bg-white/40 backdrop-blur-md border-b border-transparent"
      }`}
    >
      <nav className="max-w-[1400px] mx-auto px-5 sm:px-8 h-[72px] flex items-center justify-between">
        <Link to="/" data-testid="nav-logo" className="flex items-center gap-2.5 group">
          <img src="/kwd-logo.png" alt="Kenny Web Design" className="h-9 sm:h-10 w-auto" />
          <span className="hidden sm:block text-[11px] uppercase tracking-[0.2em] text-zinc-500 mt-0.5">Kenny Web Design</span>
        </Link>

        <div className="hidden lg:flex items-center gap-7">
          {NAV.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              data-testid={`nav-${n.label.toLowerCase().replace(/ /g, "-")}`}
              className={({ isActive }) =>
                `text-sm font-medium transition-colors hover:text-black ${isActive ? "text-black" : "text-zinc-500"}`
              }
            >
              {n.label}
            </NavLink>
          ))}
        </div>

        <div className="flex items-center gap-3">
          <Link
            to="/contact"
            data-testid="nav-cta"
            className="hidden sm:inline-flex items-center rounded-full bg-black text-white text-sm font-medium px-5 py-2.5 hover:bg-zinc-800 transition-colors"
          >
            Free Consultation
          </Link>
          <button
            data-testid="mobile-menu-toggle"
            className="lg:hidden p-2"
            onClick={() => setOpen((v) => !v)}
            aria-label="Toggle menu"
          >
            {open ? <X size={24} /> : <List size={24} />}
          </button>
        </div>
      </nav>

      {open && (
        <div data-testid="mobile-menu" className="lg:hidden bg-white border-t border-black/10 px-5 py-4">
          <div className="flex flex-col gap-1">
            {NAV.map((n) => (
              <NavLink
                key={n.to}
                to={n.to}
                className={({ isActive }) =>
                  `py-2.5 text-base font-medium ${isActive ? "text-black" : "text-zinc-600"}`
                }
              >
                {n.label}
              </NavLink>
            ))}
            <Link to="/contact" className="mt-3 text-center rounded-full bg-black text-white font-medium px-5 py-3">
              Free Consultation
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}
